import React from 'react';
//import { makeStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
//import { blue } from '@material-ui/core/colors';

import { Grid, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';

/*
const useStyles = makeStyles({
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
});
*/


export default function SimpleDialog(props) {
    const { onOk, openPriceChangeUp } = props;
    const { t } = useTranslation();

    const handleOk = () => {
        onOk();
    };

    const showMoreDeals = () => {
        const cityID = openPriceChangeUp?.city?.id;
        const cityUID = openPriceChangeUp?.city?.uid;

        window.location.href = '/' + cityUID + '/?destinations=' +cityID;
    }

    const price = openPriceChangeUp?.price;

    return (
        <Dialog maxWidth='xs' fullWidth={true} aria-labelledby="simple-dialog-title" open={openPriceChangeUp?.show} keepMounted>
            <div className='ugly modalBody p-4'>

                <Grid container id="PriceChangeUpModal" className="UserNotificationModal">
                    <Grid item className='text-center' xs={12}>
                        <div className="heading">
                            <img src="/images/modals/price-changed-heading.png" alt={t('package.modals.priceChangeUp.heading')} />
                            <h3 className="price-change-up-message">{t('package.modals.priceChangeUp.message', { price })}</h3>
                        </div>
                    </Grid>
                    <Grid item className='mb-2 text-center heading' xs={12} >
                        <div className="content">
                            <h4>{t('package.modals.priceChangeUp.question')}</h4>
                        </div>
                    </Grid>
                    <Grid item  className='text-center mb-2' xs={12}>
                        <Button onClick={handleOk} width='60%' variant='contained' color='primary' className='m-1 price-change-continue-button' title={t('common.buttons.continueBooking')}>{t('common.buttons.continueBooking')}</Button>
                        <Button onClick={showMoreDeals} variant='contained' color='inherit' className='m-1 price-change-more-deals-button' title={t('common.buttons.showMoreDeals')}>{t('common.buttons.showMoreDeals')}</Button>
                    </Grid>
                </Grid>
            </div>

        </Dialog>
    );
}
